module.exports = __webpack_public_path__ + "static/media/checkify.a776290d.png";